import RolePermissionApi from '@/api/RolePermissionApi';
import { i18n } from '@/i18n';
import { PERMISSION_ACTION } from '@/typings/enums/PERMISSION_ACTION';
import { useNotif } from '@orion.ui/orion';
import useSelfService from './SelfService';

class RolePermissionService {

	get isAgency () { return useSelfService().self.isAgency() }
	private get rolesPermissionsList () {
		return [
			{
				title: i18n.global.t('auth.role.permission.category.contracts'),
				children: [
					{
						action: PERMISSION_ACTION.ClientContractRead,
						label: this.isAgency
							? i18n.global.t('auth.role.permission.action.client.contract.read.agency')
							: i18n.global.t('auth.role.permission.action.client.contract.read.client'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.client.contract.read.description.agency')
							: i18n.global.t('auth.role.permission.action.client.contract.read.description.client'),
						onDeactivate: {
							deactivate: [
								PERMISSION_ACTION.ClientContractValidate,
								PERMISSION_ACTION.ClientContractSign,
								PERMISSION_ACTION.ContractProlongation,
							],
						},
					},
					{
						action: PERMISSION_ACTION.ClientContractValidate,
						label: i18n.global.t('auth.role.permission.action.client.contract.validate.label'),
						description: i18n.global.t('auth.role.permission.action.client.contract.validate.description'),
						onActivate: { activate: [PERMISSION_ACTION.ClientContractRead] },
					},
					{
						action: PERMISSION_ACTION.ClientContractSign,
						label: i18n.global.t('auth.role.permission.action.client.contract.sign.label'),
						description: i18n.global.t('auth.role.permission.action.client.contract.sign.description'),
						onActivate: { activate: [PERMISSION_ACTION.ClientContractRead] },
					},
					{
						action: PERMISSION_ACTION.TempWorkerContractRead,
						label: i18n.global.t('auth.role.permission.action.tempworker.contract.read.label'),
						description: i18n.global.t('auth.role.permission.action.tempworker.contract.read.description'),
					},
					{
						action: PERMISSION_ACTION.ContractProlongation,
						label: i18n.global.t('auth.role.permission.action.contract.prolongation.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.contract.prolongation.description.agency')
							: i18n.global.t('auth.role.permission.action.contract.prolongation.description.client'),
						onActivate: { activate: [PERMISSION_ACTION.ClientContractRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.bills'),
				children: [
					{
						action: PERMISSION_ACTION.BillRead,
						label: i18n.global.t('auth.role.permission.action.bill.read.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.bill.read.description.agency')
							: i18n.global.t('auth.role.permission.action.bill.read.description.client'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.registers'),
				children: [
					{
						action: PERMISSION_ACTION.RegisterRead,
						label: i18n.global.t('auth.role.permission.action.register.read.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.register.read.description.agency')
							: i18n.global.t('auth.role.permission.action.register.read.description.client'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.handicapped'),
				children: [
					{
						action: PERMISSION_ACTION.HandicappedWorkerListRead,
						label: i18n.global.t('auth.role.permission.action.handicapped.read.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.handicapped.read.description.agency')
							: i18n.global.t('auth.role.permission.action.handicapped.read.description.client'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.certificates'),
				children: [
					{
						action: PERMISSION_ACTION.CertificateRead,
						label: i18n.global.t('auth.role.permission.action.certificate.read.label'),
						description: i18n.global.t('auth.role.permission.action.certificate.read.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.salary'),
				children: [
					{
						action: PERMISSION_ACTION.SalarySlipRead,
						label: i18n.global.t('auth.role.permission.action.salary.read.label'),
						description: i18n.global.t('auth.role.permission.action.salary.read.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.withholding'),
				children: [
					{
						action: PERMISSION_ACTION.WithholdingTaxAttestationRead,
						label: i18n.global.t('auth.role.permission.action.withholding.read.label'),
						description: i18n.global.t('auth.role.permission.action.withholding.read.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.trip'),
				children: [
					{
						action: PERMISSION_ACTION.TripAttestationRead,
						label: i18n.global.t('auth.role.permission.action.trip.read.label'),
						description: i18n.global.t('auth.role.permission.action.trip.read.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.poleemploi'),
				children: [
					{
						action: PERMISSION_ACTION.PoleEmploiAttestationRead,
						label: i18n.global.t('auth.role.permission.action.poleemploi.read.label'),
						description: i18n.global.t('auth.role.permission.action.poleemploi.read.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.provision'),
				children: [
					{
						action: PERMISSION_ACTION.TempWorkerProvisionDocumentRead,
						label: i18n.global.t('auth.role.permission.action.tempworker.provision.read.label'),
						description: i18n.global.t('auth.role.permission.action.tempworker.provision.read.description'),
					},
					{
						action: PERMISSION_ACTION.ClientProvisionDocumentRead,
						label: this.isAgency
							? i18n.global.t('auth.role.permission.action.client.provision.read.label.agency')
							: i18n.global.t('auth.role.permission.action.client.provision.read.label.client'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.client.provision.read.description.agency')
							: i18n.global.t('auth.role.permission.action.client.provision.read.description.client'),
						onDeactivate: { deactivate: [PERMISSION_ACTION.ClientProvisionDocumentSign] },
					},
					{
						action: PERMISSION_ACTION.ClientProvisionDocumentSign,
						label: i18n.global.t('auth.role.permission.action.client.provision.sign.label'),
						description: i18n.global.t('auth.role.permission.action.client.provision.sign.description'),
						onActivate: { activate: [PERMISSION_ACTION.ClientProvisionDocumentRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.payment'),
				children: [
					{
						action: PERMISSION_ACTION.AdvancedPaymentDemandRead,
						label: i18n.global.t('auth.role.permission.action.payment.read.label'),
						description: i18n.global.t('auth.role.permission.action.payment.read.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.timetickets'),
				children: [
					{
						action: PERMISSION_ACTION.TimeTicketRead,
						label: i18n.global.t('auth.role.permission.action.timeticket.read.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.timeticket.read.description.agency')
							: i18n.global.t('auth.role.permission.action.timeticket.read.description.client'),
						onDeactivate: { deactivate: [PERMISSION_ACTION.TimeTicketUpdate, PERMISSION_ACTION.TimeTicketValidate] },
					},
					{
						action: PERMISSION_ACTION.TimeTicketUpdate,
						label: i18n.global.t('auth.role.permission.action.timeticket.update.label'),
						description: i18n.global.t('auth.role.permission.action.timeticket.update.description'),
						onActivate: { activate: [PERMISSION_ACTION.TimeTicketRead] },
					},
					{
						action: PERMISSION_ACTION.TimeTicketValidate,
						label: i18n.global.t('auth.role.permission.action.timeticket.validate.label'),
						description: i18n.global.t('auth.role.permission.action.timeticket.validate.description'),
						onActivate: { activate: [PERMISSION_ACTION.TimeTicketRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.signatures'),
				children: [
					{
						action: PERMISSION_ACTION.SignatureManagement,
						label: i18n.global.t('auth.role.permission.action.signature.manage.label'),
						description: i18n.global.t('auth.role.permission.action.signature.manage.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.archives'),
				children: [
					{
						action: PERMISSION_ACTION.CompanyDigitalSafeDocumentRead,
						label: i18n.global.t('auth.role.permission.action.archive.read.label'),
						description: i18n.global.t('auth.role.permission.action.archive.read.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.conditions'),
				children: [
					{
						action: PERMISSION_ACTION.ConditionRead,
						label: i18n.global.t('auth.role.permission.action.condition.read.label'),
						description: i18n.global.t('auth.role.permission.action.condition.read.description'),
						onDeactivate: { deactivate: [PERMISSION_ACTION.ConditionCreate] },
					},
					{
						action: PERMISSION_ACTION.ConditionCreate,
						label: i18n.global.t('auth.role.permission.action.condition.create.label'),
						description: i18n.global.t('auth.role.permission.action.condition.create.description'),
						onActivate: { activate: [PERMISSION_ACTION.ConditionRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.orders'),
				children: [
					{
						action: PERMISSION_ACTION.OrderRead,
						label: i18n.global.t('auth.role.permission.action.order.read.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.order.read.description.agency')
							: i18n.global.t('auth.role.permission.action.order.read.description.client'),
						onActivate: { activate: [PERMISSION_ACTION.TempWorkerUserRead] },
						onDeactivate: { deactivate: [PERMISSION_ACTION.OrderCreate, PERMISSION_ACTION.OrderUpdate] },
					},
					{
						action: PERMISSION_ACTION.OrderCreate,
						label: i18n.global.t('auth.role.permission.action.order.create.label'),
						description: i18n.global.t('auth.role.permission.action.order.create.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrderRead] },
					},
					{
						action: PERMISSION_ACTION.OrderUpdate,
						label: i18n.global.t('auth.role.permission.action.order.update.label'),
						description: i18n.global.t('auth.role.permission.action.order.update.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrderRead] },
					},
					{
						action: PERMISSION_ACTION.OrderCandidateUpdate,
						label: i18n.global.t('auth.role.permission.action.order.candidate.update.label'),
						description: i18n.global.t('auth.role.permission.action.order.candidate.update.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrderRead] },
					},
					{
						action: PERMISSION_ACTION.OrderToolbox,
						label: i18n.global.t('auth.role.permission.action.order.toolbox.label'),
						description: i18n.global.t('auth.role.permission.action.order.toolbox.description'),
						onActivate: { activate: [PERMISSION_ACTION.TempWorkerUserRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.users'),
				children: [
					{
						action: PERMISSION_ACTION.UserRead,
						label: i18n.global.t('auth.role.permission.action.user.read.label'),
						description: i18n.global.t('auth.role.permission.action.user.read.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRead] },
						onDeactivate: { deactivate: [PERMISSION_ACTION.UserUpdate, PERMISSION_ACTION.UserCreate, PERMISSION_ACTION.UserDelete] },
					},
					{
						action: PERMISSION_ACTION.UserUpdate,
						label: i18n.global.t('auth.role.permission.action.user.update.label'),
						description: i18n.global.t('auth.role.permission.action.user.update.description'),
						onActivate: { activate: [PERMISSION_ACTION.UserRead, PERMISSION_ACTION.TagRead, PERMISSION_ACTION.OrganizationRoleRead] },
					},
					{
						action: PERMISSION_ACTION.UserCreate,
						label: i18n.global.t('auth.role.permission.action.user.create.label'),
						description: i18n.global.t('auth.role.permission.action.user.create.description'),
						onActivate: { activate: [PERMISSION_ACTION.UserRead] },
					},
					{
						action: PERMISSION_ACTION.UserDelete,
						label: i18n.global.t('auth.role.permission.action.user.delete.label'),
						description: i18n.global.t('auth.role.permission.action.user.delete.description'),
						onActivate: { activate: [PERMISSION_ACTION.UserRead] },
					},
					{
						action: PERMISSION_ACTION.ClientUserRead,
						label: i18n.global.t('auth.role.permission.action.client.user.read.label'),
						description: i18n.global.t('auth.role.permission.action.client.user.read.description'),
					},
					{
						action: PERMISSION_ACTION.TempWorkerUserRead,
						label: i18n.global.t('auth.role.permission.action.tempworker.user.read.label'),
						description: i18n.global.t('auth.role.permission.action.tempworker.user.read.description'),
						onDeactivate: { deactivate: [PERMISSION_ACTION.OrderRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.organizations'),
				children: [
					{
						action: PERMISSION_ACTION.OrganizationRead,
						label: i18n.global.t('auth.role.permission.action.organization.read.label'),
						description: i18n.global.t('auth.role.permission.action.organization.read.description'),
						onDeactivate: {
							deactivate: [
								PERMISSION_ACTION.UserRead,
								PERMISSION_ACTION.OrganizationUpdate,
								PERMISSION_ACTION.MissionPlace,
								PERMISSION_ACTION.TagRead,
								PERMISSION_ACTION.OrganizationRoleRead,
								PERMISSION_ACTION.CompanySettingUpdate,
							],
						},
					},
					{
						action: PERMISSION_ACTION.OrganizationUpdate,
						label: i18n.global.t('auth.role.permission.action.organization.update.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.organization.update.description.agency')
							: i18n.global.t('auth.role.permission.action.organization.update.description.client'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRead] },
					},
					{
						action: PERMISSION_ACTION.CompanySettingUpdate,
						label: i18n.global.t('auth.role.permission.action.company.setting.update.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.company.setting.update.description.agency')
							: i18n.global.t('auth.role.permission.action.company.setting.update.description.client'),
						onActivate: {
							activate: this.isAgency
								? [PERMISSION_ACTION.OrganizationRead]
								: [PERMISSION_ACTION.OrganizationRead, PERMISSION_ACTION.CompanyUpdateDelegate],
						},
						onDeactivate: { deactivate: [PERMISSION_ACTION.CompanyUpdateDelegate] },
					},
					{
						action: PERMISSION_ACTION.CompanyLogo,
						label: i18n.global.t('auth.role.permission.action.company.logo.label'),
						description: i18n.global.t('auth.role.permission.action.company.logo.description'),
					},
					{
						action: PERMISSION_ACTION.CompanyUpdateDelegate,
						label: i18n.global.t('auth.role.permission.action.company.delegate.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.company.delegate.description.agency')
							: i18n.global.t('auth.role.permission.action.company.delegate.description.client'),
						onActivate: { activate: [PERMISSION_ACTION.CompanySettingUpdate] },
					},
					{
						action: PERMISSION_ACTION.Plugin,
						label: i18n.global.t('auth.role.permission.action.plugin.label'),
						description: i18n.global.t('auth.role.permission.action.plugin.description'),
					},
					{
						action: PERMISSION_ACTION.MissionPlace,
						label: i18n.global.t('auth.role.permission.action.mission.place.label'),
						description: i18n.global.t('auth.role.permission.action.mission.place.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.tags'),
				children: [
					{
						action: PERMISSION_ACTION.TagRead,
						label: i18n.global.t('auth.role.permission.action.tag.read.label'),
						description: i18n.global.t('auth.role.permission.action.tag.read.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRead] },
						onDeactivate: { deactivate: [PERMISSION_ACTION.TagCreate, PERMISSION_ACTION.TagUpdate, PERMISSION_ACTION.TagDelete] },
					},
					{
						action: PERMISSION_ACTION.TagCreate,
						label: i18n.global.t('auth.role.permission.action.tag.create.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.tag.create.description.agency')
							: i18n.global.t('auth.role.permission.action.tag.create.description.client'),
						onActivate: { activate: [PERMISSION_ACTION.TagRead] },
					},
					{
						action: PERMISSION_ACTION.TagUpdate,
						label: i18n.global.t('auth.role.permission.action.tag.update.label'),
						description: i18n.global.t('auth.role.permission.action.tag.update.description'),
						onActivate: { activate: [PERMISSION_ACTION.TagRead] },
					},
					{
						action: PERMISSION_ACTION.TagDelete,
						label: i18n.global.t('auth.role.permission.action.tag.delete.label'),
						description: i18n.global.t('auth.role.permission.action.tag.delete.description'),
						onActivate: { activate: [PERMISSION_ACTION.TagRead] },
					},
					{
						action: PERMISSION_ACTION.TagLink,
						label: i18n.global.t('auth.role.permission.action.tag.link.label'),
						description: i18n.global.t('auth.role.permission.action.tag.link.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.roles'),
				children: [
					{
						action: PERMISSION_ACTION.OrganizationRoleRead,
						label: i18n.global.t('auth.role.permission.action.role.read.label'),
						description: i18n.global.t('auth.role.permission.action.role.read.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRead] },
						onDeactivate: {
							deactivate: [
								PERMISSION_ACTION.OrganizationRoleCreate,
								PERMISSION_ACTION.OrganizationRoleUpdate,
								PERMISSION_ACTION.OrganizationRoleDelete,
							],
						},
					},
					{
						action: PERMISSION_ACTION.OrganizationRoleCreate,
						label: i18n.global.t('auth.role.permission.action.role.create.label'),
						description: i18n.global.t('auth.role.permission.action.role.create.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRoleRead] },
					},
					{
						action: PERMISSION_ACTION.OrganizationRoleUpdate,
						label: i18n.global.t('auth.role.permission.action.role.update.label'),
						description: i18n.global.t('auth.role.permission.action.role.update.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRoleRead] },
					},
					{
						action: PERMISSION_ACTION.OrganizationRoleDelete,
						label: i18n.global.t('auth.role.permission.action.role.delete.label'),
						description: i18n.global.t('auth.role.permission.action.role.delete.description'),
						onActivate: { activate: [PERMISSION_ACTION.OrganizationRoleRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.statistics'),
				children: [
					{
						action: PERMISSION_ACTION.Statistics,
						label: i18n.global.t('auth.role.permission.action.statistics.label'),
						description: i18n.global.t('auth.role.permission.action.statistics.description'),
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.news'),
				children: [
					{
						action: PERMISSION_ACTION.AgencyNewsRead,
						label: i18n.global.t('auth.role.permission.action.news.read.label'),
						description: i18n.global.t('auth.role.permission.action.news.read.description'),
						onDeactivate: { deactivate: [PERMISSION_ACTION.AgencyNewsCreate] },
					},
					{
						action: PERMISSION_ACTION.AgencyNewsCreate,
						label: i18n.global.t('auth.role.permission.action.news.create.label'),
						description: i18n.global.t('auth.role.permission.action.news.create.description'),
						onActivate: { activate: [PERMISSION_ACTION.AgencyNewsRead] },
					},
				],
			},
			{
				title: i18n.global.t('auth.role.permission.category.chat'),
				children: [
					{
						action: PERMISSION_ACTION.Discussion,
						label: i18n.global.t('auth.role.permission.action.discussion.label'),
						description: this.isAgency
							? i18n.global.t('auth.role.permission.action.discussion.description.agency')
							: i18n.global.t('auth.role.permission.action.discussion.description.client'),
					},
				],
			},
		] as const;
	}

	get list () { return this.rolesPermissionsList as unknown as Armado.RolePermission.ServicePermission[] }

	async permissionGuardAsync (
		permission: keyof typeof PERMISSION_ACTION,
		message = i18n.global.t('auth.permission.guardMessage')) {
		return new Promise<void>((resolve) => {
			if (useSelfService().self.can(permission)) {
				resolve();
			}
			else {
				useNotif.warning(message);
			}
		});
	}

	async updateAsync (...args: Parameters<typeof RolePermissionApi.update>) {
		const { data } = await RolePermissionApi.update(...args);
		return data;
	}

	async selfAsync (...args: Parameters<typeof RolePermissionApi.self>) {
		const { data } = await RolePermissionApi.self(...args);
		return data;
	}

	async getDefaultListByUserTypeAsync (...args: Parameters<typeof RolePermissionApi.getDefaultListByUserType>) {
		const { data } = await RolePermissionApi.getDefaultListByUserType(...args);
		return data;
	}

}

const rolePermissionsServiceSingleton = new RolePermissionService();

export default function useRolePermissionsService () {
	return rolePermissionsServiceSingleton;
}
